<div class="loading-container">
    <div class="spin-animation"
    [ngClass]="{
      'spin-animation--sm': size === 'sm',
      'spin-animation--md': size === 'md',
      'spin-animation--lg': size === 'lg'
    }">
    </div>
</div>



